import { render, staticRenderFns } from "./FrogVideoCard.vue?vue&type=template&id=b0ea5690&"
import script from "./FrogVideoCard.vue?vue&type=script&lang=js&"
export * from "./FrogVideoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports